import { useEffect, useState } from "react";

/**
 * Table area fills the viewport; `.pagination_align` inside the same wrapper
 * stays visible so the page itself does not scroll.
 */
export function useTableMaxHeight(ref, minHeight = 240, bottomPadding = 48, options = {}) {
  const [tableMaxHeight, setTableMaxHeight] = useState(null);
  const deps = Array.isArray(options.deps) ? options.deps : [];

  useEffect(() => {
    const updateMaxHeight = () => {
      const el = ref.current;
      if (!el) return;
      const top = el.getBoundingClientRect().top;
      const footer = el.querySelector(".pagination_align");
      const footerH = footer ? footer.getBoundingClientRect().height : 0;
      setTableMaxHeight(Math.max(minHeight, window.innerHeight - top - bottomPadding - footerH));
    };

    const scheduleUpdate = () => {
      requestAnimationFrame(updateMaxHeight);
    };

    scheduleUpdate();
    window.addEventListener("resize", scheduleUpdate);

    const parent = ref.current?.closest(".dashboard_inner") || ref.current?.parentElement;
    const ro =
      typeof ResizeObserver !== "undefined" ? new ResizeObserver(scheduleUpdate) : null;
    if (ro && parent) ro.observe(parent);
    if (ro && ref.current && ref.current !== parent) ro.observe(ref.current);

    return () => {
      window.removeEventListener("resize", scheduleUpdate);
      ro?.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- caller passes layout deps via options.deps
  }, [ref, minHeight, bottomPadding, ...deps]);

  return tableMaxHeight;
}
